import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Image as ImageIcon, Check } from 'lucide-react';
export function Perms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-607">
      <div className="container mx-auto px-6 md:px-12" data-id="element-608">
        {/* HERO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-20" data-id="element-609">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-ink mb-6" data-id="element-610">
            Хімічна та біозавивка
          </h1>
          <p className="text-muted text-lg md:text-xl font-normal leading-relaxed" data-id="element-611">
            Створення ідеальних локонів з максимальною турботою про здоров'я
            волосся. Використовуємо лише перевірені безпечні засоби.
          </p>
        </motion.div>

        {/* DIFFERENCE BLOCK */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="grid md:grid-cols-2 gap-6 mb-24 max-w-4xl mx-auto" data-id="element-612">
          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-613">
            <h3 className="text-xl font-semibold text-ink mb-3" data-id="element-614">
              Хімічна завивка
            </h3>
            <p className="text-muted leading-relaxed" data-id="element-615">
              Стійкий результат, підходить для пружних локонів
            </p>
          </div>
          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-616">
            <h3 className="text-xl font-semibold text-ink mb-3" data-id="element-617">Біозавивка</h3>
            <p className="text-muted leading-relaxed" data-id="element-618">
              М'який склад, менш агресивна для волосся, природні хвилі
            </p>
          </div>
        </motion.div>

        {/* PRICE SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-2xl mx-auto mb-24" data-id="element-619">
          <div className="text-center mb-12" data-id="element-620">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-621">
              Прайс
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full mb-4" data-id="element-622"></div>
            <p className="text-sm text-muted" data-id="element-623">
              (ціна залежить від довжини волосся)
            </p>
          </div>

          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-624">
            <h3 className="text-xl font-semibold text-ink mb-6 pb-4 border-b border-line" data-id="element-625">
              БІОзавивка
            </h3>
            <ul className="space-y-4" data-id="element-626">
              {[{
              name: 'Зона маківки',
              price: '650–700 грн'
            }, {
              name: 'До середини шиї',
              price: '1200–1400 грн'
            }, {
              name: 'До плечей',
              price: '1500–1700 грн'
            }, {
              name: 'Нижче плечей',
              price: '1700–1900 грн'
            }, {
              name: 'Нижче лопаток',
              price: '2000–2300 грн'
            }, {
              name: 'До пояса',
              price: '2500–3500 грн'
            }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-627">
                  <span className="text-muted" data-id="element-628">{item.name}</span>
                  <span className="font-semibold text-ink" data-id="element-629">{item.price}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        {/* WHY SAFE BLOCK */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="max-w-2xl mx-auto mb-24" data-id="element-630">
          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-631">
            <ul className="space-y-4" data-id="element-632">
              {['Тільки перевірена косметика світових брендів', 'Індивідуальний підбір складу під тип волосся', 'Консультація перед процедурою'].map((item, i) => <li key={i} className="flex items-start" data-id="element-633">
                  <div className="bg-white p-1 rounded-full border border-line mr-4 mt-0.5 shadow-sm" data-id="element-634">
                    <Check className="text-ink flex-shrink-0" size={14} strokeWidth={3} data-id="element-635" />
                  </div>
                  <span className="text-ink font-medium text-base" data-id="element-636">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        {/* PORTFOLIO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-24" data-id="element-637">
          <div className="text-center mb-12" data-id="element-638">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-639">
              Мої роботи
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-640"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-641">
            {[1, 2, 3].map(i => <div key={i} className="aspect-[3/4] bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm" data-id="element-642">
                <div className="text-center flex flex-col items-center" data-id="element-643">
                  <ImageIcon className="text-muted mb-3" size={32} strokeWidth={1.5} data-id="element-644" />
                  <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-645">
                    Фото роботи
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* CTA SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="max-w-md mx-auto flex flex-col gap-4" data-id="element-646">
          <a href="/#contact" className="w-full py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-647">
            Записатися
          </a>
          <Link to="/#services" className="w-full py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-648">
            До всіх послуг
          </Link>
        </motion.div>
      </div>
    </main>;
}